module.exports = __webpack_public_path__ + "img/logo_horizontal.2e53a535.svg";